export type PaymentMethodType = {
  id: string | number
  expiresDate: string
  endCode: string
  paymentName: string
  imgUrl: string
}

export const payments: PaymentMethodType[] = [
  {
    id: '1',
    expiresDate: '07/08',
    endCode: '3456',
    paymentName: 'visa',
    imgUrl: '/assets/wallet/visa.png',
  },
  // {
  // 	id: '2',
  // 	expiresDate: '10/08',
  // 	endCode: '8966',
  // 	paymentName: 'paypal',
  // 	imgUrl: '/assets/wallet/visa.png',
  // },
]
